export function getMsg(msgCode, ...params) {
  const message = {
    maxFileSize: "ファイルサイズが上限を超えるためアップロードできません。",
    MSG001: "本当にこの" + params[0] + "を削除してもよろしいですか？",
    MSG002: "チェックを入れた" + params[0] + "を" + params[1] + "してもよろしいですか？",
    MSG003: "既存の営業担当者を上書きしますか？",
    MSG004: "元データには2名しか選択できません。",
    MSG005: "個人と法人の名寄せはできません。",
    MSG006:
      "「名寄せ後データ」のとおり名寄せを行います。\r\n上記項目のうち選択されていない情報はすべて削除され、\r\n元に戻せませんが、本当に名寄せしてもよろしいですか？",
    MSG007: "「名寄せ元データ」の" + params[0] + "が一致していませんが、本当に名寄せしてもよろしいですか？",
    MSG008: "検索結果が" + params[0] + "件を超えました。" + params[1] + "件目まで表示します。",
    MSG009: "この関連案件との紐づけを解除してもよろしいですか？",
    MSG010: "入力された" + params[0] + "は既に存在します。",
    MSG011: "保険会社と団体の組み合わせが正しくありません。",
    MSG012: "被保険者に登録する顧客が見つかりませんでした。\r\n顧客を新規作成して、被保険者に登録しますか？",
    MSG013: "対応履歴を登録しました。\r\n続けて対応予定も登録しますか？",
    MSG014: "選択した顧客は、他世帯の世帯主のため登録できません。",
    MSG015: "この顧客を単身世帯として登録します。\r\nよろしいですか？",
    MSG016: "世帯主の住所が変更されました。\r\n同居している顧客の住所も変更しますか？",
    MSG017: "申込商品を選択してください。",
    MSG018:
      "本当にこの商品マスタを削除してもよろしいですか？\r\n販売期間が終了して案内を停止したい場合は、削除ではなく販売期間を変更して保存してください。\r\n販売期間の終了ではなく、この商品マスタを削除したい場合は以下の「はい」ボタンを選択してください。",
    MSG019: "入力された団体コードは既に存在します。",
    MSG020:
      "入力された団体コードは削除済です。\r\nこの団体コードで登録してもよろしいですか？\r\n※削除済の団体からは団体コードが削除されます。",
    MSG021:
      "本当にこの団体を削除してもよろしいですか？ \r\nこの団体に紐づく第2階層・第3階層・予定・履歴も削除されます。",
    MSG022: "案件進捗に入力した日付を元に対応履歴を自動登録しました。\r\n対応履歴を追記しますか？",
    MSG023: "入力された募集企画番号は既に存在します。",
    MSG024: "入力中の情報を保存して、顧客条件抽出画面に遷移してもよろしいですか？",
    MSG025: "内容が変更されています。\r\n変更を保存しますか？",
    MSG026: "チェックを入れた担当者を一括変更してもよろしいですか？",
    MSG027: "既存の担当者を上書きしますか？",
    MSG028: "同一の顧客を名寄せすることはできません。",
    MSG029: "マスタ管理者は1名以上必須です。",
    MSG030:
      "該当する比較・推奨商品がありません。「1. ご希望の保障分野」「2. お客様のご意向」の組み合わせを見直すか、マスタ設定をご確認ください。",
    MSG031: "枠内に署名されていません。\r\nこのまま登録すると署名画像なしになりますがよろしいですか？",
    MSG032: "最終確認完了後は一切編集ができなくなります。\r\n最終確認を完了してもよろしいでしょうか？",
    MSG033: "営業担当者または処理担当者を選択してください。",
    MSG034:
      "チェックを入れた対応予定の対応者を一括変更してもよろしいですか？ \r\n既存の対応者情報は上書きされ、元に戻せません。\r\n対応者を変更すると、予定の対応出先と対応部署も変更されます。",
    MSG035: "集計期間は最大1年間を指定してください。",
    MSG036:
      "本当にこの特約マスタを削除してもよろしいですか？ \r\n販売期間が終了する場合は、削除ではなく販売期間を変更して登録してください。 \r\n販売期間の終了ではなく、誤登録等でこの特約マスタを削除したい場合は以下の「はい」ボタンをクリックしてください。",
    MSG037: "募集企画対象者一覧を登録しました。\r\n登録された対象者は募集企画対象者一覧画面で検索できます。",
    MSG038: "案件を一括登録しました。登録された案件は「案件検索」「顧客情報」等の画面でご確認ください。",
    MSG039: "登録可能な顧客件数を超えています。\r\n管理者にお問い合わせください。",
    MSG040: params[0] + "には正しい日付を入力してください。",
    MSG041: "チェックを入れた顧客に顧客分類「" + params[0] + "」を一括登録してもよろしいですか？",
    MSG042: "チェックを入れた顧客から顧客分類「" + params[0] + "」を一括削除してもよろしいですか？",
    MSG043:
      params[0] +
      "件の該当レコードが見つかりました。 + \r\n + params[1] + 件以内になるように条件を変更してください。",
    MSG044: "既に削除された顧客が選択されています。\r\n再度検索して検索結果を更新してください。",
    MSG045: "該当する顧客が見つかりませんでした。\r\n新規登録しますか？",
    MSG046: params[0] + "検索条件を入力してください。",
    MSG047: "この機能を利用するには郵便番号を登録する必要があります。",
    MSG048: "検索結果を一括削除します。\r\n一括削除したら元に戻せませんが、本当に削除してもよろしいですか？",
    MSG049: "名寄せする顧客を2件選択してください。",
    MSG050: "該当データは既に削除されています。\r\n再度検索して検索結果を更新してください。",
    MSG051: "未対応の必須アクションがあります。",
    MSG052: "該当するデータが見つかりませんでした。",
    MSG053: "被保険者氏名欄にスペースの入力がないため、新規顧客の氏名をすべて姓として登録しますがよろしいですか？",
    MSG054: "特約が登録されているため、" + params[0] + "を変更することはできません。",
    MSG055: "正しいパスワードを入力してください。",
    MSG056: "この関連案件との紐づけを解除してもよろしいですか？",
    MSG057: "PDFファイル、JPGファイル、JPEGファイル、PNGファイルのいずれかを選択してください。",
    MSG058: params[0] + "を選択してください。",
    MSG059: "添付可能なデータ容量の上限を超えるためアップロードできません。",
    MSG060: "ファイルが存在しません。",
    MSG061: "ファイルサイズが正しくありません。\r\nファイルを確認して再度実行してください。",
    MSG062: "比較・推奨のチェックを外すと提案商品も削除されますがよろしいですか？",
    MSG063: "ファイル名が" + params[0] + "文字を超えています。",
    MSG064: "ファイル名に禁止文字が含まれています。",
    MSG065: "同じ名前のファイルが既に存在します。",
    MSG066: "データを選択してください。",
    MSG067:
      "顧客情報の営業担当者が一括登録され、該当ユーザのマイページの「システム推奨募集対象」に選択した顧客が出力されます。\r\nこの処理を実行してもよろしいですか？",
    MSG068: params[0] + "は" + params[1] + "文字で入力してください。",
    MSG069: "登録が完了しました。",
    MSG070: "最新の意向が変更されています。変更理由を入力してください。",
    MSG071:
      "本当にこの団体第2階層を削除してもよろしいですか？\r\nこの団体第2階層に紐づく第3階層・予定・履歴も削除されます。",
    MSG072:
      "本当にこの団体第3階層を削除してもよろしいですか？\r\nこの団体第3階層に紐づく予定・履歴も削除されます。",
    MSG073: "変更してもよろしいですか？",
    MSG074: "変更を保存しました。",
    MSG075: "ご意向のふり返りに漏れがあります。",
    MSG077: "本当にこの出先を削除してもよろしいですか？\r\nこの出先に紐づく部署も削除されます。",
    MSG078: "この提案商品は見送り日が登録されているため、申込商品にすることができません。",
    MSG079: params[0] + "を保存しました。",
    MSG080: params[0] + "を入力してください。",
    MSG081:
      "最新の意向が変更されたことにより、" +
      params[0] +
      "が商品候補から外れます。この案件から比較・推奨中のこれらの商品を削除してもよろしいですか？",
    MSG082: "正しい" + params[0] + "を入力してください。",
    MSG083: params[0] + "件の案件を更新しました。",
    MSG084: params[0] + "件の案件、" + params[1] + "件の提案商品を更新しました。",
    MSG085: params[0] + "の最大文字数を超えるため、" + params[1] + "を登録できません。",
    MSG088: params[0] + "は" + params[1] + "までしか選択できません。",
    MSG089: "同一世帯の証券、対応予定、対応履歴、案件も印刷しますか?",
    MSG090:
      "データ種類に「全量」が選択されています。\r\nファイルに含まれていない当該保険会社の証券情報は全て無効になり、元に戻せませんがよろしいですか？",
    MSG091: "ファイルサイズの合計が上限（" + params[0] + "）を超えるためアップロードできません。",
    MSG092: params[0] + "の閲覧権限がありません。",
    MSG093:
      "案件の営業担当者と顧客の営業担当者が異なります。この案件の営業担当者は自分の顧客のみ閲覧可能なユーザのため登録できません。",
    MSG094:
      "一括登録する" +
      params[0] +
      "と顧客の営業担当者が異なるデータあります。\r\n自分の顧客のみ閲覧可能なユーザは自分が営業担当者でない顧客の" +
      params[1] +
      "を登録することができません。",
    MSG095: "適合性確認に漏れがあります。",
    MSG096: "適合性確認サブ項目は必ず1つ以上選択してください。",
    MSG097:
      "一括変更する" +
      params[0] +
      "と顧客の営業担当者が異なるデータあります。\r\n自分の顧客のみ閲覧可能なユーザは自分が営業担当者でない顧客の" +
      params[1] +
      "を登録することができません。",
    MSG098: "この顧客の編集権限がありません。",
    MSG099: "TNet契約種目データではありません。",
    MSG100: "選択した証券は既に案件が登録されているため、登録できません。",
    MSG101: "選択した証券は既に案件が登録されているため、一括変更できません。",
    MSG102:
      "満期更改案件を一括登録しました。登録された満期更改案件は「案件検索」「顧客情報」「マイページ」等の画面でご確認ください。",
    MSG103:
      "この証券情報は損保満期更改案件に使用されています。この証券情報を削除すると損保満期更改案件も削除されますがよろしいですか？",
    MSG104:
      "選択した証券担当者に「証券担当者コード」が設定されていません。\r\n証券担当者を登録するには、事前にユーザマスタで「証券担当者コード」を登録する必要があります。",
    MSG105: "リモート署名URLの有効期限が切れています。",
    MSG106: "署名情報が取得できませんでした。",
    MSG107: "リモート署名依頼の後は一切編集ができなくなります。 \r\nリモート署名を完了してもよろしいでしょうか？",
    MSG112: "ファイル数が上限（" + params[0] + "件）を超えるためアップロードできません。"
  };
  return message[msgCode];
}
